/*----------------------
   HOME PRODUCTS
---------------------- */
HomeProducts = {
    init: function () {
        $(".swiper--home-products").each(function () {
            if (this.swiper) {
                this.swiper.update();
                return;
            }

            new Swiper(this, {
                slidesPerView: "auto",
                spaceBetween: 12,
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                freeMode: {
                    enabled: true,
                    sticky: false,
                    momentumBounce: false

                },
                breakpoints: {
                    0: {
                        spaceBetween: 8
                    },
                    769: {
                        spaceBetween: 12
                    }
                }
            });
        });

        $(".home-product-card__add").off("click.homeProducts").on("click.homeProducts", function (e) {
            e.preventDefault();

            const button = $(this);
            const productID = button.attr("data-id");
            if (!productID || button.hasClass("product-adding")) return;

            button.addClass("product-adding");

            $.post(
                window.Shopify.routes.root + "cart/add.js",
                { items: [{ id: Number(productID), quantity: 1 }], sections: "section-cart-notification" },
                null,
                "json"
            )
                .done(function (data) {
                    const cartEl = $(".cart-notification__products");
                    if (cartEl.length && data.sections && data.sections["section-cart-notification"]) {
                        cartEl.empty();
                        cartEl.append($(data.sections["section-cart-notification"]).html());
                    }

                    if (window.CartNotification && typeof CartNotification.refresh === "function") {
                        CartNotification.refresh();
                    }

                    $(".cart-notification").addClass("cart-notification-active");
                    $("body").addClass("cart-notification-open");
                })
                .fail(function (data) {
                    if (data.responseJSON && data.responseJSON.description) {
                        alert(data.responseJSON.description);
                    }
                })
                .always(function () {
                    button.removeClass("product-adding");
                });
        });
    }
};

$(document).ready(function () {
    HomeProducts.init();
});

$(document).on("shopify:section:load", function () {
    HomeProducts.init();
});
